<template>
  <div class="serviceTerms">
    <Navbar title="用户服务条款" :default-bg="false"/>
    <div class="text" v-html="$xss(text)"></div>
  </div>
</template>

<script>
import Navbar from "../components/NavBar";

export default {
  name: "serviceTerms",
  components: {Navbar},
  data() {
    return {
      text: ""
    }
  },
  created() {
    this.getServiceTerms();
  },
  methods: {
    getServiceTerms() {
      this.$post('article/serviceTerms').then(result => {
        this.text = result.data;
      });
    }
  }
}
</script>

<style scoped lang="less">
.serviceTerms {
  .text {
    padding: 0 15px;
    box-sizing: border-box;
  }

  p {
    padding: 0;
    margin: 0;
  }
}
</style>